//import nav from '@/_nav'
import i18n from '@/plugins/i18n.js';
var vsprintf = require('sprintf-js').vsprintf;

var options = {
   withheader: true,
   withcolumns: true,
   fieldseparator: ',',
   lineseparator: "\n",
   out_codejournal: 'VT',
   out_folio: '000',
   out_padtime: 'T00:00:00',
   out_reglt: 'VI30',
   out_period_1: 'PERIODE : ',
   out_period_2: ' AU ',
   invoice_numeric_id_offset: 10000,
   creditnote_numeric_id_offset: 0,
   compte_client_generique: '41100000',
   compte_tva: '44571000',
}

/*
 * A TITRE INDICATIF, format de l'export "Factures" avec le template "Prestige"
 * CETTE STRUCTURE N'EST PAS UTILISEE, ELLE EST LA, POUR RAPPEL
 */
var template_zoho_invoice = [
   { column: 'A', name: 'Invoice Date'   , _pk:   1, value: null },
   { column: 'B', name: 'Invoice Number' , _pk:   2, value: null },
   { column: 'C', name: 'Customer Name'  , _pk:   3, value: null },
   { column: 'D', name: 'Item Price'     , _pk:   4, value: null },
   { column: 'E', name: 'Period begins'  , _pk:   5, value: null },
   { column: 'F', name: 'Period ends'    , _pk:   6, value: null },
   { column: 'G', name: 'Account Code'   , _pk:   7, value: null },
   { column: 'H', name: 'Item Tax'       , _pk:   8, value: null },
   { column: 'I', name: 'Billing Address', _pk:   9, value: null },
   { column: 'J', name: 'Billing City'   , _pk:  10, value: null },
   { column: 'K', name: 'Billing Code'   , _pk:  11, value: null },
   { column: 'L', name: 'Item Total'     , _pk:  12, value: null },
   { column: 'M', name: 'Item Tax Amount', _pk:  13, value: null },
   { column: 'N', name: 'Total'          , _pk:  14, value: null },
];

/*
 * A TITRE INDICATIF, format de l'export "Factures d'avoir" avec le template "Prestige"
 * Pour certains avoirs, il y a un décalage de 2 champs, à partir de colonne 'E', avant que
 * le template "Prestige" soit au point.
 * CETTE STRUCTURE N'EST PAS UTILISEE, ELLE EST LA, POUR RAPPEL
 */
var template_zoho_creditnote = [
   { column: 'A', name: 'Invoice Date'   , _pk:   1, value: null },
   { column: 'B', name: 'Invoice Number' , _pk:   2, value: null },
   { column: 'C', name: 'Customer Name'  , _pk:   3, value: null },
   { column: 'D', name: 'Item Price'     , _pk:   4, value: null },
   { column: 'E', name: 'Period begins'  , _pk:   5, value: null },
   { column: 'F', name: 'Period ends'    , _pk:   6, value: null },
   { column: 'G', name: 'Account Code'   , _pk:   7, value: null },
   { column: 'H', name: 'Item Tax'       , _pk:   8, value: null },
   { column: 'I', name: 'Billing Address', _pk:   9, value: null },
   { column: 'J', name: 'Billing City'   , _pk:  10, value: null },
   { column: 'K', name: 'Billing Code'   , _pk:  11, value: null },
   { column: 'L', name: 'Item Total'     , _pk:  12, value: null },
   { column: 'M', name: 'Item Tax Amount', _pk:  13, value: null },
   { column: 'N', name: 'Total'          , _pk:  14, value: null },
];

var matches = [
   { _pk : 'A', _pk_to : 1 }
];

var template_prestige = {
   customerline: {
      type: 'C', name: 'Ligne de compte', 
      columns : [
         { column: 'A', name: 'Type ligne'           , _pk:   1, value: 'C' , start:   0, length:   1 },
         { column: 'B', name: 'Numéro de compte'     , _pk:   2, value: null, start:   1, length:   8 },
         { column: 'C', name: 'Libellé'              , _pk:   3, value: null, start:   9, length:  30 },
         { column: 'D', name: 'Clé alpha'            , _pk:   4, value: null, start:  39, length:   7 },
         { column: 'E', name: 'Montant débit N-1'    , _pk:   5, value: null, start:  46, length:  13 },
         { column: 'F', name: 'Montant crédit N-1'   , _pk:   6, value: null, start:  59, length:  13 },
         { column: 'G', name: 'Montant débit N-2'    , _pk:   7, value: null, start:  72, length:  13 },
         { column: 'H', name: 'Montant crédit N-2'   , _pk:   8, value: null, start:  85, length:  13 },
         { column: 'F', name: 'Compte collectif'     , _pk:   9, value: null, start:  98, length:   8 },
         { column: 'G', name: 'Addresse, ligne 1'    , _pk:  10, value: null, start: 106, length:  30 },
         { column: 'G', name: 'Addresse, ligne 2'    , _pk:  11, value: null, start: 136, length:  30 },
         { column: 'G', name: 'Ville'                , _pk:  12, value: null, start: 166, length:  30 },
         { column: 'G', name: 'Téléphone'            , _pk:  13, value: null, start: 196, length:  20 },
         { column: 'F', name: 'MAJ Compte si existan', _pk:  14, value:  '1', start: 216, length:   1 },
         { column: 'H', name: 'Type de compte'       , _pk:  15, value:  'C', start: 217, length:   1 },
         { column: 'H', name: 'Compte à centraliser' , _pk:  16, value: null, start: 218, length:   1 },
         { column: 'I', name: 'Domicialisation'      , _pk:  17, value: null, start: 219, length:  30 },
         { column: 'I', name: 'RIB'                  , _pk:  18, value: null, start: 249, length:  30 },
         { column: 'I', name: 'Mode règlement, 2c'   , _pk:  19, value: null, start: 279, length:   2 },
         { column: 'I', name: 'Jours échéance'       , _pk:  20, value: null, start: 281, length:   2 },
         { column: 'I', name: 'Terme échéance, le'   , _pk:  21, value: null, start: 283, length:   2 },
         { column: 'I', name: 'Départ calcul échéance', _pk: 22, value: null, start: 285, length:   2 },
         { column: 'I', name: 'Code TVA, 2c'         , _pk:  23, value: null, start: 287, length:   2 },
         { column: 'I', name: 'Contrepartie'         , _pk:  24, value: null, start: 289, length:   8 },
         { column: 'I', name: 'Nombre jours échéance', _pk:  25, value: null, start: 297, length:   8 },
         { column: 'I', name: 'TVA encaiss/décaiss'  , _pk:  26, value: null, start: 300, length:   1 },
         { column: 'I', name: 'Fax'                  , _pk:  27, value: null, start: 301, length:  20 },
      ]
   },
   movementline: {
      type: 'M', name: 'Ligne d\'écriture',
      columns : [
         { column: 'A', name: 'Type ligne'           , _pk:  1, value: 'M' , start:   0, length:   1 },
         { column: 'B', name: 'Compte Client'        , _pk:  2, value: null, start:   1, length:   8 },
         { column: 'C', name: 'Code Journal'         , _pk:  3, value: null, start:   9, length:   2 },
         { column: 'D', name: 'Numéro Folio'         , _pk:  4, value: null, start:  11, length:   3 },
         { column: 'E', name: 'Date écriture'        , _pk:  5, value: null, start:  14, length:   6 },
         { column: 'F', name: 'Code libellé'         , _pk:  6, value: null, start:  20, length:   1 },
         { column: 'G', name: 'Libellé'              , _pk:  7, value: null, start:  21, length:  20 },
         { column: 'H', name: 'Sens écriture'        , _pk:  8, value: null, start:  41, length:   2 },
         { column: 'I', name: 'Montant'              , _pk:  9, value: null, start:  43, length:  13 },
         { column: 'J', name: 'Contrepartie'         , _pk: 10, value: null, start:  55, length:   8 },
         { column: 'K', name: 'Echéance'             , _pk: 11, value: null, start:  63, length:   6 },
         { column: 'L', name: 'Code Lettrage'        , _pk: 12, value: null, start:  69, length:   2 },
         { column: 'L', name: 'Code statistiques'    , _pk: 13, value: null, start:  71, length:   3 },
         { column: 'M', name: 'Numéro de pièce'      , _pk: 14, value: null, start:  74, length:   5 },
         { column: 'N', name: 'Code Affaire'         , _pk: 15, value: null, start:  79, length:  10 },
         { column: 'O', name: 'Quantité 1'           , _pk: 16, value: null, start:  89, length:  10 },
         { column: 'P', name: 'Numéro de pièce NDF'  , _pk: 17, value: null, start:  99, length:   8 },
         { column: 'Q', name: 'Code Devise'          , _pk: 18, value: null, start: 107, length:   3 },
         { column: 'R', name: 'Code Journal'         , _pk: 19, value: null, start: 110, length:   3 },
         { column: 'S', name: 'Flag code TVA'        , _pk: 20, value: null, start: 113, length:   1 },
         { column: 'S', name: 'Code TVA'             , _pk: 21, value: null, start: 114, length:   1 },
         { column: 'S', name: 'Méthode de calcul TVA', _pk: 22, value: null, start: 115, length:   1 },
         { column: 'T', name: 'Libellé'              , _pk: 23, value: null, start: 116, length:  30 },
         { column: 'T', name: 'Code TVA 2 caractères', _pk: 24, value: null, start: 146, length:   2 },
         { column: 'U', name: 'Numéro de pièce'      , _pk: 25, value: null, start: 148, length:  10 },
         { column: 'U', name: 'Filler 1'             , _pk: 26, value: null, start: 158, length:  10 },
         { column: 'U', name: 'Montant dans la devise', _pk: 27, value: null, start: 168, length:  13 },
         { column: 'U', name: 'Pièce jointe'         , _pk: 28, value: null, start: 181, length:  12 },
         { column: 'U', name: 'Quantité 2'           , _pk: 29, value: null, start: 193, length:  38 },
         { column: 'U', name: 'Numéro Unique'        , _pk: 30, value: null, start: 203, length:  10 },
         { column: 'U', name: 'Code Opérateur'       , _pk: 31, value: null, start: 213, length:   4 },
         { column: 'U', name: 'Date système'         , _pk: 32, value: null, start: 217, length:  14 },
      ]
   },
}

export default {
   name: "zoho_to_prestige",

   components: {
      i18n,
   },

   data: () => {
      return {
         result: [],
         router: null,
         api: null,
         current_customer: null,
         current_invoice: null,
         invoice_numeric_id: null,
         attachment: null,
      }
   },

   methods: {

      async retrieve_invoice(inv_code) {
         var { errorinfos, api_response } = await this.caller.$api.getRow(this.caller.$router,'invoice', inv_code );
         return { errorinfos, api_response }
      },

      async update_invoice(inv_pk) {
         var { errorinfos, api_response } = await this.caller.$api.updateRow(this.caller.$router, 'invoice', inv_pk, {}, 'export_accounting' );
         return { errorinfos, api_response }
      },

      convert_date(date,mask) {
         function pad(s) { return (s < 10) ? '0' + s : s; }
         var result = mask;
         var year = ''+date.getFullYear();
         result = result.replace('yyyy',pad(year));
         result = result.replace('yy',pad(year.substring(2)));
         result = result.replace('mm',pad(date.getMonth()+1));
         result = result.replace('dd',pad(date.getDate()));
         return result;
      },

      conpute_due_date(date,code) {
         var result = date;
         switch (code) {
            case 'VI30' :
               result.setDate(result.getDate()+30);
               break;
         }
         return result;
      },

      pad_leading_zeros(value,length) {
         var result = ''+parseInt(value);
         if ( length-result.length>=0 ) {
            result = "0".repeat(length-result.length) + result;
         }
         return result
      },

      pad_line(fields) {
         var result = '';
         for ( var i=0;i<fields.length;i++ ) {
            result = result + ( fields[i].value==null ? '' : fields[i].value );
            result = result.padEnd(fields[i].start+fields[i].length)
         }
         return result
      },

      build_result_type_C(fields) {
         var output = JSON.parse(JSON.stringify(template_prestige.customerline.columns));
         if ( fields.length>0) {
            var out_row = null;
            this.current_invoice = fields[1];
            this.current_invoice = this.current_invoice.replace('-','0');

            /*
             * FIRST : we have to detect if the row is an invoice, or a credit note.
             *   we do that, by checking fields[1], which is the invoice number. Begins by 'F' for invoice, and 'C' for credit note
             * SECOND : some all credit notes do no have start and end dates. 
             *   If they have such dates, fields[4] and [5] are dates,
             *   If not, fields[4] is the sales account, which begins by '7'
             *   So, if not, fields must be switched to the left, by 2 positions
             */
            let row_nature = 'I';
            if ( fields[1].charAt(0)=='C' ) { row_nature='CN'; }
            let index_addr1 = 8;
            if ( row_nature=='CN' && fields[4].charAt(0)=='7' ) {
               index_addr1 = 6;
            }
            let index_addr2 = index_addr1+1;
            let index_addr3 = index_addr2+1;
   
            out_row = this.caller.$api._get_by_pk(output,2);
            out_row.value = this.current_customer.cus_quadratuscode;
            out_row = this.caller.$api._get_by_pk(output,3);
            out_row.value = this.current_customer.cus_name;
            out_row = this.caller.$api._get_by_pk(output,4);
            out_row.value = this.current_customer.cus_code.substring(0,7);
            out_row = this.caller.$api._get_by_pk(output,9);
            out_row.value = options.compte_client_generique;
            out_row = this.caller.$api._get_by_pk(output,10);
            out_row.value = fields[index_addr1].substring(0,30);
            out_row = this.caller.$api._get_by_pk(output,12);
            // column 12 is 'CodePostal'+'Ville'
            out_row.value = fields[index_addr3].substring(0,5)+fields[index_addr2].substring(0,25);
            
            if ( row_nature=='I' ) {
               this.invoice_numeric_id = parseInt(this.current_invoice.substring(6)) + options.invoice_numeric_id_offset;
            } else {
               this.invoice_numeric_id = parseInt(this.current_invoice.substring(6)) + options.creditnote_numeric_id_offset;
            }
            this.attachment = this.pad_leading_zeros(this.invoice_numeric_id,8)+'.pdf';
         }
         var out_line = this.pad_line(output);
         this.result.push(out_line);
         return out_line;
      },

      build_result_type_M(fields) {
         var output = JSON.parse(JSON.stringify(template_prestige.movementline.columns));
         var date, date1, date2 = null;
         var out_line = null;

         /*
          * FIRST : we have to detect if the row is an invoice, or a credit note.
          *   we do that, by checking fields[1], which is the invoice number. Begins by 'F' for invoice, and 'C' for credit note
          * SECOND : some all credit notes do no have start and end dates. 
          *   If they have such dates, fields[4] and [5] are dates,
          *   If not, fields[4] is the sales account, which begins by '7'
          *   So, if not, fields must be switched to the left, by 2 positions
         */
         let row_nature = 'I';
         if ( fields[1].charAt(0)=='C' ) { row_nature='CN'; }

         let index_date1 = 4;
         let index_date2 = 5;
         let index_saleaccount = 6;
         let index_price1 = 11;
         let index_D_or_C = 'D';
         let index_C_or_D = 'C';

         if ( row_nature=='CN' ) {
            index_D_or_C = 'C';
            index_C_or_D = 'D';   
         }
         if ( row_nature=='CN' && fields[4].charAt(0)=='7' ) {
            index_date1 = null;
            index_date2 = null;
            index_saleaccount = 4;
            index_price1 = 9;
         }
         let index_price2 = index_price1+1;
         let index_price3 = index_price2+1;

         date  = new Date(this.current_customer.inv_date+options.out_padtime);
         if ( index_date1!=null ) { date1 = new Date(fields[index_date1]+options.out_padtime); }
         if ( index_date2!=null ) { date2 = new Date(fields[index_date2]+options.out_padtime); }
         
         if ( fields.length>0) {
            var out_row = null;
            /*
             * Fields for first record ('M') ("compte client") and for all other records ('M'), eventually
             */
            out_row = this.caller.$api._get_by_pk(output,2);
            out_row.value = this.current_customer.cus_quadratuscode;
            out_row = this.caller.$api._get_by_pk(output,3);
            out_row.value = options.out_codejournal;
            out_row = this.caller.$api._get_by_pk(output,4);
            out_row.value = options.out_folio;
            out_row = this.caller.$api._get_by_pk(output,5);
            out_row.value = this.convert_date(date,"ddmmyy");
            out_row = this.caller.$api._get_by_pk(output,6);
            out_row.value = this.current_invoice.substring(0,1);
            out_row = this.caller.$api._get_by_pk(output,7);
            out_row.value = this.current_invoice.padEnd(12)+options.out_reglt;
            out_row = this.caller.$api._get_by_pk(output,8);
            out_row.value = index_D_or_C;
            out_row = this.caller.$api._get_by_pk(output,9);
            out_row.value = this.pad_leading_zeros(100*parseFloat(fields[index_price3]),out_row.length-1);
            out_row = this.caller.$api._get_by_pk(output,11);
            date = new Date(this.current_customer.inv_date+options.out_padtime);
            out_row.value = this.convert_date(this.conpute_due_date(date,options.out_reglt),"ddmmyy");
            out_row = this.caller.$api._get_by_pk(output,14);
            out_row.value = this.pad_leading_zeros(this.invoice_numeric_id,5);
            out_row = this.caller.$api._get_by_pk(output,23);
            out_row.value = this.current_invoice.padEnd(12)+options.out_reglt.padEnd(8)+this.convert_date(date,"dd/mm/yyyy");;
            out_row = this.caller.$api._get_by_pk(output,25);
            out_row.value = this.current_invoice.substring(1);
            out_row = this.caller.$api._get_by_pk(output,28);
            out_row.value = this.attachment;

            out_line = this.pad_line(output);
            this.result.push(out_line);

            /*
             * Fields for all further records ('M') (so, excluding the first one)
             */
            out_row.value = '';
            out_row = this.caller.$api._get_by_pk(output,8);
            out_row.value = index_C_or_D;
            out_row = this.caller.$api._get_by_pk(output,11);
            out_row.value = '';
            out_row = this.caller.$api._get_by_pk(output,28);
            if ( date1!=null ) {
               out_row.value = this.attachment+options.out_period_1+this.convert_date(date1,"dd/mm/yy")+options.out_period_2+this.convert_date(date2,"dd/mm/yy");
            } else {
               out_row.value = this.attachment;
            }

            /*
             * Fields for second record ('M') : ("compte de vente")
             */
            out_row = this.caller.$api._get_by_pk(output,2);
            out_row.value = fields[index_saleaccount];
            out_row = this.caller.$api._get_by_pk(output,9);
            out_row.value = this.pad_leading_zeros(Math.round(100*parseFloat(fields[index_price1])),out_row.length-1);
            out_row = this.caller.$api._get_by_pk(output,28);
            if ( date1!=null ) {
               out_row.value = this.attachment+options.out_period_1+this.convert_date(date1,"dd/mm/yy")+options.out_period_2+this.convert_date(date2,"dd/mm/yy");
            } else {
               out_row.value = this.attachment;
            }

            out_line = this.pad_line(output);
            this.result.push(out_line);

            /*
             * Fields for third record ('M') : ("compte TVA")
             */
            out_row = this.caller.$api._get_by_pk(output,2);
            out_row.value = options.compte_tva;
            out_row = this.caller.$api._get_by_pk(output,9);
            out_row.value = this.pad_leading_zeros(100*parseFloat(fields[index_price2]),out_row.length-1);
            out_row = this.caller.$api._get_by_pk(output,28);
            out_row.value = this.attachment;

            out_line = this.pad_line(output);
            this.result.push(out_line);
         }
      },

      async build_result_line(rank,line,trackinglist,exporttoaccounting,includeaccounting) {
         var input = line.split(options.fieldseparator);
         if ( input.length>1) {
            var inv_code = input[1];
            var { errorinfos, api_response } = await this.retrieve_invoice(inv_code);
            var row = { _pk: rank+1, inv_code: inv_code, inv_total_price: null, inv_tracking_code: 0, inv_tracking_message: '' };
            if ( api_response.error==0 ) {
               this.current_customer = api_response.row;
               row.cus_name = api_response.row.cus_name;
               row.ins_name = api_response.row.ins_name;
               row.inv_exported_to_accounting = api_response.row.inv_exported_to_accounting;
               row.inv_total_price = api_response.row.inv_total_price;
               if ( row.inv_exported_to_accounting==true ) {
                  row.inv_tracking_code = 1;
                  row.inv_tracking_message = vsprintf(i18n.t('messages.inv_tracking_message_already_flagged'),[inv_code])
               }
               if ( row.inv_tracking_code==0 || includeaccounting==true ) {
                  this.build_result_type_C(input);
                  this.build_result_type_M(input);
                  this.result.push('');
                  if ( exporttoaccounting==true ) {
                     let { errorinfos : errorinfos2, api_response: api_response2 } = await this.update_invoice(api_response.row.inv_pk);
                     if ( api_response2.error==0 ) {
                        if ( includeaccounting==true ) {
                           row.inv_tracking_message = vsprintf(i18n.t('messages.inv_tracking_message_row_included'),[inv_code])
                        } else {
                           row.inv_tracking_message = vsprintf(i18n.t('messages.inv_tracking_message_now_flagged'),[inv_code])
                        }
                     }
                  }
               }
            } else {
               row.inv_tracking_message = vsprintf(i18n.t('messages.inv_tracking_message_not_found'),[inv_code])
               row.inv_tracking_code = 2;
            }
            trackinglist.rows.push(row);
         }
      },

      retrieve_fields_in_line(line) {
         var result = [];
         var line_type = line.charAt(0);
         if ( line_type=='C' ) {
            for( var i=0;i<template_prestige.customerline.columns.length;i++ ) {
               var value = line.substring(template_prestige.customerline.columns[i].start,template_prestige.customerline.columns[i].start+template_prestige.customerline.columns[i].length);
               result.push( { name: template_prestige.customerline.columns[i].name, value: value.trim() } );
            }
         }
         if ( line_type=='M' ) {
            for( var i=0;i<template_prestige.movementline.columns.length;i++ ) {
               var value = line.substring(template_prestige.movementline.columns[i].start,template_prestige.movementline.columns[i].start+template_prestige.movementline.columns[i].length);
               result.push( { name: template_prestige.movementline.columns[i].name, value: value.trim() } );
            }
         }
         return result;
      },

      async build_respond(text,exporttoaccounting,includeaccounting,trackinglist,caller) {
         this.result = [];
         this.caller = caller;
         const lines = text.split(options.lineseparator);
         if ( lines.length>0 ) {
            for ( var i=0;i<lines.length;i++ ) {
               if ( lines[i].length>0 ) {
                  await this.build_result_line(i,lines[i],trackinglist,exporttoaccounting,includeaccounting);  // populates 'this.result'
               }
            }
         }
         return this.result;
      }

   }
}
